import SEGMENTED_TABS_CLASS_NAME from '../../constants/tabs';

const segmentedTabs = ({ theme }) => ({
  alignSelf: 'center',
  minHeight: 0,
  padding: theme.spacing(1),
  borderRadius: 8,
  backgroundColor: theme.palette.gray.A200,
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTab-root': {
    ...theme.typography.small_2,
    fontWeight: 600,
    height: 'auto',
    minHeight: 0,
    minWidth: 168,
    padding: theme.spacing(0.5, 1),
    borderRadius: 4,
    textTransform: 'none',
    color: theme.palette.gray.A500,
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
});

const MuiTabs = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${SEGMENTED_TABS_CLASS_NAME}`]: segmentedTabs({ theme }),
    }),
  },
};

export default MuiTabs;
